import React from 'react'
import { Link, useParams } from 'react-router-dom'
import { Profilebar } from '../Profile/Profilebar'
import { postdata } from '../contents/postdata'
import NoCover from '../images/NoCover.png'
import './View.css'
import Multiline from '../Elements/Multiline'

export default function View(props: any) {
  let uid: string | undefined = useParams().uid
  if (uid == undefined) uid = ''
  let postid: string | undefined = useParams().id
  if (postid == undefined) postid = ''
  let data: { [key: string]: string } = {
    title: '404　このページは存在しません',
    cover: '',
    tag: '',
    body: 'このページは存在しないまたは削除された可能性があります。',
    href: '',
    createdAt: '',
  }
  // uid、postidがpostdataに存在するか調べる
  if (uid in postdata && postid in postdata[uid]) data = postdata[uid][postid]
  if (data.cover == '') data.cover = NoCover

  window.scrollTo(0, 0)
  return (
    <div>
      <Profilebar profid={uid} />
      <div className="viewpage">
        <img className="viewpage-mainimage" src={data.cover}></img>
        <div className="viewpage-rightbody">
          <hr className="viewpage-border" />
          <h2 className="viewpage-title">{data.title}</h2>
          <p className="viewpage-mainbody">
            <Multiline data={data.body} />
          </p>
          <p className="viewpage-posted-date">{data.createdAt}</p>
          {data.href != '' ? (
            <a className="viewpage-button" href={data.href}>
              <p>見てみる</p>
            </a>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  )
}
